module.exports = __webpack_public_path__ + "static/logoWhite-74a948b04a4df591f0fc4df61f33eca8.svg";